import { useCallback, useEffect, useRef, useState } from 'react';

/** Copia para a área de transferência e devolve `copied` por ~900ms (feedback visual). */
export function useCopy(duration = 900) {
  const [copied, setCopied] = useState(false);
  const timer = useRef<ReturnType<typeof setTimeout>>();
  useEffect(() => () => clearTimeout(timer.current), []);
  const copy = useCallback(
    (text: string) => {
      navigator.clipboard?.writeText(text).catch(() => {});
      setCopied(true);
      clearTimeout(timer.current);
      timer.current = setTimeout(() => setCopied(false), duration);
    },
    [duration],
  );
  return { copied, copy };
}
